import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { defaultBusinessGasDetailsAddons, defaultEstimatesDialog } from './common/planDefaults';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';

export const originBusinessUsageAdvantage: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Usage Advantage']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['Benefit period is 12 months', 'No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue:
              PLAN_DETAILS_PLAN_PERIOD.Months12 +
              CONTENT_SEPARATOR +
              PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '12 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: defaultBusinessGasDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_rates-variable.svg',
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'For high usage businesses. Variable usage and supply rates. Offer ends 30 June 2026.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/business-usage-advantage',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
